import parsePhoneNumberFromString from 'libphonenumber-js/mobile'

import { API } from '@/api/API'
import type { SmsOutboundAvailableRequest } from '@/api/types/payloads'

interface SmsAvailabilityResult {
  smsAvailable: boolean
  countryCode?: string
}

export function isValidUsPhoneNumber(phoneNumber: string): boolean {
  if (!phoneNumber) return false
  const parsed = parsePhoneNumberFromString(phoneNumber)
  return !!parsed && parsed.isValid() && parsed.country === 'US'
}

export function checkSmsAvailability(phoneNumber: string): Promise<SmsAvailabilityResult> {
  const body: SmsOutboundAvailableRequest = { sms_to: phoneNumber }
  return API.post<'sms_status'>('sms/outbound/available', { body }).then((response) => {
    const status = response.sms_status._data[0]
    if (!status) {
      return { smsAvailable: false }
    }
    return {
      smsAvailable: status.sms_available,
      countryCode: status.country_code,
    }
  })
}
